let _this;
export default{
  name:"Menu",
  data(){
    return {
      logoUrl:'../../../../static/img/logo.png',
    }
  },
  filters: {
    customDisplay: function (value) {
      if( _this ){
        return _this.ApiService.getConfigFieldsText(value);
      } else {
        return value;
      }
    }
  },
  mounted(){
    _this = this;
  },
  methods:{
    //切换一级菜单
    changeMenu: (e) => {
      let parents = $(e.target).parents('li');
      let parentSiblings = parents.siblings();
      if (parents.find('ul').length === 0) {
        parentSiblings.find('ul').slideUp();
        parentSiblings.find('i.arrow.open').removeClass('open');
      } else {
        parentSiblings.find('ul.first').slideUp();
        parentSiblings.find('i.arrow.open').removeClass('open');
        parents.find('.arrow').toggleClass('open');
        parents.find('ul.first').slideToggle()
      }
      //因为菜单阻止了冒泡导致右上角的弹窗不关闭，所以需要自动click
      //document.getElementById("sidebar").click();
    },
    //二级菜单
    changeChildMenu: (e) => {
      let target = $(e.target);
      let parentSiblings = target.parent('li.second-menu').siblings();
      parentSiblings.find('ul').slideUp();
      let parents = target.parents('li.second-menu');
      if (parents.find('ul').length > 0) {
        parents.find('ul').slideToggle();
      }
      //因为菜单阻止了冒泡导致右上角的弹窗不关闭，所以需要自动click
      //document.getElementById("sidebar").click();
    },
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/menu/menu.js